
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $95839dac9ac56cb6$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"8LrZ8\",\"services.88faa854.js\",\"kfcaX\",\"corporate.d49e33a2.mp4\",\"7loMb\",\"povesti-de-brand.5c91879e.mp4\",\"awJbq\",\"demo-produs.67588b56.mp4\",\"1KjfJ\",\"social-first.dca984b6.mp4\",\"gvO76\",\"fotografie-produs.bbcef9a7.mp4\",\"lTIfO\",\"filmari-on-location-2.b3213104.mp4\"]"));

var $0f2f471a80ac0905$exports = {};
$0f2f471a80ac0905$exports = new URL("corporate.d49e33a2.mp4", import.meta.url).toString();


var $629bd0c392146f4a$exports = {};
$629bd0c392146f4a$exports = new URL("povesti-de-brand.5c91879e.mp4", import.meta.url).toString();


var $59ecaaec8b253a0a$exports = {};
$59ecaaec8b253a0a$exports = new URL("demo-produs.67588b56.mp4", import.meta.url).toString();


var $684a9fd080dbeb92$exports = {};
$684a9fd080dbeb92$exports = new URL("social-first.dca984b6.mp4", import.meta.url).toString();


var $54dbc2364cbe30a5$exports = {};
$54dbc2364cbe30a5$exports = new URL("fotografie-produs.bbcef9a7.mp4", import.meta.url).toString();


var $6487abbc5fb455d1$exports = {};
$6487abbc5fb455d1$exports = new URL("filmari-on-location-2.b3213104.mp4", import.meta.url).toString();


const $52d5bb163b6f78c0$var$previewVideos = {
    corporate: new URL($0f2f471a80ac0905$exports).href,
    "povesti-brand": new URL($629bd0c392146f4a$exports).href,
    "demo-produs": new URL($59ecaaec8b253a0a$exports).href,
    "social-first": new URL($684a9fd080dbeb92$exports).href,
    "fotografie-produs": new URL($54dbc2364cbe30a5$exports).href,
    "filmari-on-location": new URL($6487abbc5fb455d1$exports).href
};
function $52d5bb163b6f78c0$export$5535e9d9aca07944(slug) {
    return $52d5bb163b6f78c0$var$previewVideos[slug] || null;
}


const $425745d2de12c7d0$var$OFFSET_X = 28;
const $425745d2de12c7d0$var$OFFSET_Y = 28;
const $425745d2de12c7d0$var$TRAIL_SPEED = 0.18;
function $425745d2de12c7d0$export$d30c0b8bee647cf3() {
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return;
    const container = document.getElementById("services-container");
    const preview = document.getElementById("cursorVideoPreview");
    const video = preview?.querySelector("video");
    if (!container || !preview || !video) return;
    let activeTrigger = null;
    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    let isVisible = false;
    function lerp(start, end, factor) {
        return start + (end - start) * factor;
    }
    function updatePosition() {
        if (isVisible) {
            currentX = lerp(currentX, targetX, $425745d2de12c7d0$var$TRAIL_SPEED);
            currentY = lerp(currentY, targetY, $425745d2de12c7d0$var$TRAIL_SPEED);
            preview.style.left = `${currentX}px`;
            preview.style.top = `${currentY}px`;
        }
        requestAnimationFrame(updatePosition);
    }
    function showPreview(trigger, clientX, clientY) {
        const url = (0, $52d5bb163b6f78c0$export$5535e9d9aca07944)(trigger.dataset.previewVideo);
        if (!url) return;
        if (video.getAttribute("src") !== url) {
            video.src = url;
            video.load();
        }
        video.play().catch(()=>{});
        currentX = clientX + $425745d2de12c7d0$var$OFFSET_X;
        currentY = clientY + $425745d2de12c7d0$var$OFFSET_Y;
        targetX = currentX;
        targetY = currentY;
        preview.classList.add("active");
        isVisible = true;
        activeTrigger = trigger;
    }
    function hidePreview() {
        isVisible = false;
        activeTrigger = null;
        preview.classList.remove("active");
        video.pause();
    }
    container.addEventListener("mouseover", (event)=>{
        const trigger = event.target.closest(".service-hover-video");
        if (!trigger || !container.contains(trigger)) return;
        if (trigger === activeTrigger) return;
        showPreview(trigger, event.clientX, event.clientY);
    });
    container.addEventListener("mouseout", (event)=>{
        const trigger = event.target.closest(".service-hover-video");
        if (!trigger || !container.contains(trigger)) return;
        const related = event.relatedTarget;
        if (related && trigger.contains(related)) return;
        if (activeTrigger === trigger) hidePreview();
    });
    container.addEventListener("mousemove", (event)=>{
        if (!activeTrigger) return;
        targetX = event.clientX + $425745d2de12c7d0$var$OFFSET_X;
        targetY = event.clientY + $425745d2de12c7d0$var$OFFSET_Y;
    });
    document.addEventListener("languageChanged", hidePreview);
    requestAnimationFrame(updatePosition);
}
if (document.body.classList.contains("services")) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $425745d2de12c7d0$export$d30c0b8bee647cf3);
    else $425745d2de12c7d0$export$d30c0b8bee647cf3();
}


//# sourceMappingURL=services.88faa854.js.map
